import TemplateNav from '@/components/Template/Navigation.vue'
import TemplateMain from '@/components/Template/Main.vue'
import ProjectsMain from '@/components/Projects/Main.vue'
import ProjectsNav from '@/components/Projects/Navigation.vue'
import PanelNav from '@/components/Panel/index.vue'
import SceneMain from '@/components/Scene/index.vue'
import PlaceholdersMain from '@/components/Placeholders/Main.vue'
import PlaceholdersNav from '@/components/Placeholders/Navigation.vue'

export const routes = [
    {
        path: '/templates',
        name: 'templates',
        components: {
            navigation: TemplateNav,
            main: TemplateMain
        }
    },
    {
        path: '/templates/placeholders',
        name: 'placeholders',
        components: {
            navigation: PlaceholdersNav,
            main: PlaceholdersMain
        }
    },
    {
        path: '/:templateName',
        name: 'templateProjects',
        components: {
            navigation: ProjectsNav,
            main: ProjectsMain
        }
    },
    {
        path: '/:projectName',
        name: 'editProject',
        components: {
            navigation: PanelNav,
            main: SceneMain
        }
    }
    
]